<template>
  <b-container v-if="savedMemory !== null" fluid>
    <div class="top-panel-space">
      <b-form-group>
        <b-input-group>
          <b-form-input
            placeholder="Search"
            :value="search || ''"
            @keyup="debounceSearch"
          ></b-form-input>
          <b-input-group-append>
            <b-btn variant="secondary" @click="clearSearch">
              <i class="fa fa-eraser"></i>
            </b-btn>
          </b-input-group-append>
        </b-input-group>
      </b-form-group>
    </div>

    <div class="layoutcard storytable">
      <div class="d-flex justify-content-between mb-2">
        <span v-if="search === '' || search === null" class="scolledStatus"
          >Showing
          <strong>
            {{ currentPage > 2 ? (currentPage - 2) * perPage : 0 }} -
            {{ currentPage * perPage }}
          </strong>
          of {{ totalRows }} {{ inFocus }}s</span
        >
        <span v-else class="scolledStatus"
          >Found <strong>{{ totalRows }}</strong> {{ inFocus }}s</span
        >
        <!--<span class="p-0 btn ml-auto">
          <i class="fa fa-filter" />
          Show Filter Badges
        </span>-->
        <span class="p-0 btn">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            fill="currentColor"
            class="bi bi-bookmark-check-fill"
            viewBox="0 0 16 16"
          >
            <path
              fill-rule="evenodd"
              d="M2 15.5V2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v13.5a.5.5 0 0 1-.74.439L8 13.069l-5.26 2.87A.5.5 0 0 1 2 15.5zm8.854-9.646a.5.5 0 0 0-.708-.708L7.5 7.793 6.354 6.646a.5.5 0 1 0-.708.708l1.5 1.5a.5.5 0 0 0 .708 0l3-3z"
            />
          </svg>
          <!-- <i class="fa fa-bookmark bookmark" />  -->
          ( {{ bookmarks.length }} ) Bookmarks
        </span>
      </div>

      <div class="top-bars">
        <div class="d-flex justify-content-between no-wrap">
          <div
            v-for="page in totalPages"
            :key="page"
            v-b-tooltip.hover
            class="page"
            :title="'Jump to ' + page + ' of ' + totalPages"
            @click="jumpToPage(page)"
          ></div>
        </div>

        <div class="mid-bar">
          <b-progress :max="totalRows" variant="secondary">
            <b-progress-bar :value="scrolled * perPage"></b-progress-bar>
          </b-progress>
        </div>

        <div>
          <b-progress :max="totalRows" variant="info" striped>
            <b-progress-bar
              :value="currentPage * perPage"
            ></b-progress-bar>
          </b-progress>
        </div>
      </div>

      <div id="bookmarks" class="bookmarks">
        <div
          v-for="(bookmark, i) in bookmarks"
          :key="i"
          v-b-tooltip.hover
          class="bookmark"
          :style="{ left: getLeftMargin(bookmark.topic) + 'px' }"
          :title="bookmark.bookmark"
          @click="goToBookmark(bookmark.topic)"
        ></div>
      </div>

      <b-table-simple
        id="scrollerDivTable"
        sticky-header
        hover
        small
        class="table-ttc"
      >
        <b-thead>
          <b-tr>
            <b-th>
              <button class="btn p-0" @click.prevent="changeInFocus('topic')">
                <i
                  class="fa fa-square-full pr-1"
                  :class="{ activeBadge: inFocus === 'topic' }"
                />
                <span>Topics</span>
              </button>
            </b-th>
            <b-th class="w-80">
              <b-table-simple small class="m-0 p-0">
                <b-tbody>
                  <b-tr>
                    <b-th class="border-0 w-1 p-0 m-0">
                      <button class="btn p-0" @click="changeInFocus('theme')">
                        <i
                          class="fa fa-square-full pr-1"
                          :class="{ activeBadge: inFocus === 'theme' }"
                        />
                        <span>Themes</span>
                      </button>
                    </b-th>
                    <b-th class="border-0 p-0 m-0">
                      <span>Concepts</span>
                    </b-th>
                  </b-tr>
                </b-tbody>
              </b-table-simple>
            </b-th>
            <b-th
              class="font-weight-bold text-right w-6 sortinactive"
              :class="{ sorter: sortType === 'size' }"
              @click="sortTtc('size')"
            >
              <div class="d-flex align-items-center">
                <i
                  :class="
                    sortType === 'size' && sortDir === 'desc'
                      ? 'fa fa-caret-down'
                      : 'fa fa-caret-up'
                  "
                  class="mr-2"
                >
                </i>
                <span>Size</span>
              </div>
            </b-th>
            <b-th
              class="font-weight-bold text-right w-6 sortinactive"
              :class="{ sorter: sortType === 'recency' }"
              @click="sortTtc('recency')"
            >
              <div class="d-flex align-items-center">
                <i
                  :class="
                    sortType === 'recency' && sortDir === 'desc'
                      ? 'fa fa-caret-down'
                      : 'fa fa-caret-up'
                  "
                  class="mr-2"
                >
                </i>
                <span>Recency</span>
              </div>
            </b-th>
            <b-th class="w-5"></b-th>
          </b-tr>
        </b-thead>
        <b-tbody class="table-ttc-body">
          <b-tr v-for="(topic, i) in dataItems" :key="i">
            <b-td class="w-10">
              <draggable
                :list="[topic]"
                :group="{ name: 'annotations', pull: 'clone', put: false }"
              >
                <i
                  class="cursor-grab fa fa-square-full"
                  :class="{ activeBadge: inFocus === 'topic' }"
                  :style="'color:' + topic.colors[colorMetric].bg"
                  @click="showOptionsPanel(topic)"
                />
              </draggable>
            </b-td>
            <b-td class="p-0">
              <b-table-simple class="m-0">
                <b-tbody>
                  <b-tr v-for="theme in topic.children" :key="theme.id">
                    <b-td
                      v-if="
                        (search && searchedThemes.includes(theme.id)) ||
                        (filterFocused && filteredThemes.includes(theme.id)) ||
                        (!search && !filterFocused)
                      "
                      class="border-0 w-10"
                    >
                      <draggable
                        :list="[theme]"
                        :group="{
                          name: 'annotations',
                          pull: 'clone',
                          put: false,
                        }"
                      >
                        <i
                          class="cursor-grab fa fa-square-full"
                          :class="{ activeBadge: inFocus === 'theme' }"
                          :style="'color:' + theme.colors[colorMetric].bg"
                          @click="showOptionsPanel(theme)"
                        />
                      </draggable>
                    </b-td>
                    <b-td
                      v-if="
                        (search && searchedThemes.includes(theme.id)) ||
                        (filterFocused && filteredThemes.includes(theme.id)) ||
                        (!search && !filterFocused)
                      "
                      class="border-0 td-concepts"
                    >
                      <draggable
                        :list="theme.children"
                        :group="{
                          name: 'annotations',
                          pull: 'clone',
                          put: false,
                        }"
                      >
                        <b-badge
                          v-for="c in theme.children"
                          :key="c._id"
                          class="mr-1 cursor-grab"
                          :class="{ filterBadge: getAssociatedFilters(c.id) }"
                          :style="
                            'border-radius: 0 !important; border-bottom-style: solid; border-bottom-width: 3px; background: #ffffff; font-weight: 600;' +
                            'border-bottom-color:' +
                            c.colors[colorMetric].bg +
                            '; color:' +
                            c.colors[colorMetric].text
                          "
                          @click="showOptionsPanel(c)"
                        >
                          {{ c.name }}
                        </b-badge>
                      </draggable>
                    </b-td>
                  </b-tr>
                </b-tbody>
              </b-table-simple>
            </b-td>
            <b-td class="small text-right w-6">
              <b-table-simple
                v-if="inFocus === 'topic'"
                class="inner-table-sm m-0"
              >
                <b-tbody>
                  <b-tr>
                    <b-td class="border-0 text-right">{{ topic.size }}</b-td>
                  </b-tr>
                </b-tbody>
              </b-table-simple>
              <b-table-simple
                v-if="inFocus === 'theme'"
                class="inner-table-sm m-0"
              >
                <b-tbody>
                  <b-tr v-for="theme in topic.children" :key="theme.id">
                    <b-td class="border-0 text-right">{{ theme.size }}</b-td>
                  </b-tr>
                </b-tbody>
              </b-table-simple>
            </b-td>
            <b-td class="small text-right w-6">
              <b-table-simple
                v-if="inFocus === 'topic'"
                class="inner-table-sm m-0"
              >
                <b-tbody>
                  <b-tr>
                    <b-td class="border-0 text-right">
                      {{ topic.recency | round(2, true) }}
                    </b-td>
                  </b-tr>
                </b-tbody>
              </b-table-simple>
              <b-table-simple
                v-if="inFocus === 'theme'"
                class="inner-table-sm m-0"
              >
                <b-tbody>
                  <b-tr v-for="theme in topic.children" :key="theme.id">
                    <b-td class="border-0 text-right">
                      {{ topic.recency | round(2, true) }}
                    </b-td>
                  </b-tr>
                </b-tbody>
              </b-table-simple>
            </b-td>
            <b-td class="text-center">
              <button
                v-if="isBookmark(topic.id)"
                class="btn p-0 bookmarker"
                align="right"
                @click="removeBM(topic.id)"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  fill="currentColor"
                  class="bi bi-bookmark-check-fill"
                  viewBox="0 0 16 16"
                >
                  <path
                    fill-rule="evenodd"
                    d="M2 15.5V2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v13.5a.5.5 0 0 1-.74.439L8 13.069l-5.26 2.87A.5.5 0 0 1 2 15.5zm8.854-9.646a.5.5 0 0 0-.708-.708L7.5 7.793 6.354 6.646a.5.5 0 1 0-.708.708l1.5 1.5a.5.5 0 0 0 .708 0l3-3z"
                  />
                </svg>
              </button>
              <button
                v-if="!isBookmark(topic.id)"
                class="btn p-0 bookmarker"
                align="right"
                @click="addBM(topic.id)"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  fill="currentColor"
                  class="bi bi-bookmark"
                  viewBox="0 0 16 16"
                >
                  <path
                    d="M2 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v13.5a.5.5 0 0 1-.777.416L8 13.101l-5.223 2.815A.5.5 0 0 1 2 15.5V2zm2-1a1 1 0 0 0-1 1v12.566l4.723-2.482a.5.5 0 0 1 .554 0L13 14.566V2a1 1 0 0 0-1-1H4z"
                  />
                </svg>
              </button>
            </b-td>
          </b-tr>
        </b-tbody>
      </b-table-simple>
    </div>

    <AddBookmarkModal @submit="addBookmarkSubmit"></AddBookmarkModal>
  </b-container>
</template>

<script>
import _ from "lodash";
import round from "vue-round-filter";
import draggable from "vuedraggable";
import { mapActions, mapState } from "vuex";
import { EventBus } from "@/eventBus";
import DataSettings from "@/helpers/DataSettings";
import AddBookmarkModal from "../Shared/AddBookmarkModal";

export default {
  name: "TTCTable",
  components: {
    draggable,
    AddBookmarkModal,
  },
  filters: {
    round,
  },
  props: {
    savedMemory: {
      type: Object,
      required: false,
      default: null,
    },
    settings: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      storyLoaded: false,
      scrollLine: null,
      scrolled: 1,
      colorMetric: "recency",
      fields: ["topic", "theme", "concepts", "size", "recency"],
      currentPage: 1,
      perPage: 30,
      perPageOptions: [
        { value: 5, text: "5 per page" },
        { value: 10, text: "10 per page" },
        { value: 15, text: "15 per page" },
        { value: 30, text: "30 per page" },
        { value: 50, text: "50 per page" },
      ],
      search: "",
      dataItems: [],
      inFocus: "topic",
      sortType: null,
      sortDir: null,
      bookmarks: [],
      currBm: null,
      sizeLimit: [0, 9999],
      recencyLimit: [-3, 3],
      limitReady: false,
      searchedThemes: [],
      filteredThemes: [],
      assocFilters: [],
      showFilterbadge: true
    };
  },
  computed: {
    ...mapState({
      apiReady: (state) => state.api.apiReady,
      filters: (state) => state.filter.filters,
      filterIndex: (state) => state.filter.filterIndex,
      filterFocused: (state) => state.filter.filterFocused,
      ttc: (state) => state.ttc.ttc,
      ttcColorMetric: (state) => state.ttc.ttcColorMetric,
    }),
    colorMetricOptions() {
      return [
        { value: "recency", text: "Color on recency" },
        { value: "size", text: "Color on size" },
        {
          value: "filter_recency",
          text: "Color on filter recency",
          disabled: !this.filterFocused,
        },
        {
          value: "filter_size",
          text: "Color on filter size",
          disabled: !this.filterFocused,
        },
      ];
    },
    ttcFiltered() {
      let filtered = [];
      let toFilter = [];
      if (this.filterFocused) {
        _.each(this.ttc, (topic) => {
          if (topic.filterSize > 0) {
            let addToResult = false;
            let filteredThemes = [];
            _.each(topic.children, (theme) => {
              if (theme.filterSize > 0) {
                let found = _.filter(theme.children, (t) => t.filterSize > 0);
                if (found.length > 0) {
                  addToResult = true;
                  filteredThemes.push(theme);
                }
              }
            });
            if (addToResult) {
              toFilter.push(topic);
            }
            addToResult = false;
          }
        });
      } else {
        toFilter = this.ttc;
      }
      if (this.search) {
        _.each(toFilter, (topic) => {
          let addToResult = false;
          let filteredThemes = [];
          let topicTemp = topic;
          _.each(topic.children, (theme) => {
            let found = false;
            _.each(theme.children, (concept) => {
              found = concept.name
                .toLowerCase()
                .includes(this.search.toLowerCase());
              if (found) {
                return false;
              }
            });
            if (found) {
              addToResult = true;
              filteredThemes.push(theme);
              return false;
            }
          });
          if (addToResult) {
            filtered.push(topicTemp);
          }
          addToResult = false;
        });
        return filtered;
      } else {
        filtered = toFilter;
        if (this.inFocus === "topic") {
          if (this.sortType) {
            filtered = _.sortBy(filtered, [this.sortType]);
            if (this.sortDir === "desc") {
              filtered = _.reverse(filtered);
            }
          }
        }
        if (this.inFocus === "theme") {
          let themesBased = [];
          filtered.forEach((t) => {
            t.children.forEach((th) => {
              themesBased.push({
                id: t.id,
                type: t.type,
                recency: th.recency,
                size: th.size,
                colors: th.colors,
                children: [th],
              });
            });
          });
          filtered = themesBased;
          if (this.sortType) {
            filtered = _.sortBy(filtered, [this.sortType]);
            if (this.sortDir === "desc") {
              filtered = _.reverse(filtered);
            }
          }
        }
        filtered = _.filter(filtered, (o) => {
          return (
            o.size >= this.sizeLimit[0] &&
            o.size <= this.sizeLimit[1] &&
            o.recency >= this.recencyLimit[0] &&
            o.recency <= this.recencyLimit[1]
          );
        });
        return filtered;
      }
    },
    totalPages() {
      return Math.ceil(this.ttcFiltered.length / this.perPage);
    },
    totalRows() {
      return this.ttcFiltered.length;
    },
  },
  watch: {
    ttc() {
      this.ttcForFirstPage();
    },
    sizeLimit() {
      console.log("size cahnged");
      if (this.storyLoaded) {
        this.ttcResults(0, this.perPage);
        this.currentPage = 1;
      }
    },
    recencyLimit() {
      console.log("recency cahnged");
      if (this.storyLoaded) {
        this.ttcResults(0, this.perPage);
        this.currentPage = 1;
      }
    },
    colorMetric(val) {
      this.saveTTCColorMetric({ ttcColorMetric: val });
    },
    filterFocused(val) {
      this.currentPage = 1;
      this.clearSearch();
      this.$emit("setDefaults", {
        color: this.ttcColorMetric,
        colorOptions: this.colorMetricOptions,
        sizeRange: [
          _.minBy(this.ttc, "size").size,
          _.maxBy(this.ttc, "size").size,
        ],
        recencyRange: [-3, 3],
      });
      // Set colorMetric to global size/recency when colorMetric is set to filter size/recency and filter is disabled
      // The filter size/recency options in the dropdown will also be disabled via the computed colorMetricOptions
      if (val === null) {
        if (this.colorMetric === "filter_size") {
          this.colorMetric = "size";
        }
        if (this.colorMetric === "filter_recency") {
          this.colorMetric = "recency";
        }
      }
    },
    currentPage(newValues) {
      DataSettings.setSettings("story.currentPage", newValues);
      //this.loadFilters();
    },
    scrolled(newValues) {
      DataSettings.setSettings("story.scrolled", newValues);
      //this.loadFilters();
    },
    search(newValues) {
      if (newValues) {
        DataSettings.setSettings("story.search", newValues);
        //this.loadFilters();
      } else {
        DataSettings.setSettings("story.search", this.search);
        //this.loadFilters();
      }
    },
    inFocus(newValues) {
      DataSettings.setSettings("story.inFocus", newValues);
      //this.loadFilters();
    },
    bookmarks(newValues) {
      DataSettings.setSettings("story.bookmarks", newValues);
      //this.loadFilters();
    },
    sortType(newValues) {
      DataSettings.setSettings("story.sortType", newValues);
      //this.loadFilters();
    },
    sortDir(newValues) {
      DataSettings.setSettings("story.sortDir", newValues);
      //this.loadFilters();
    },
    settings(newValues) {
      this.colorMetric = newValues.color;
      this.sizeLimit = newValues.sizeLimit;
      this.recencyLimit = newValues.recencyLimit;
    },
  },
  mounted() {
    this.$emit("setDefaults", {
      color: this.ttcColorMetric,
      colorOptions: this.colorMetricOptions,
      sizeRange: [
        _.minBy(this.ttc, "size").size,
        _.maxBy(this.ttc, "size").size,
      ],
      recencyRange: [-3, 3],
    });
    this.getscrollLine();
    this.scroll();
    this.invokeStoredValues().then(() => {
      this.storyLoaded = true;
      this.saveLoadingStep("Done");
      this.loadAnimEnd();
    });
  },
  methods: {
    ...mapActions(["saveTTCColorMetric", "loadFilters","loadAnimStart","loadAnimEnd","saveLoadingStep"]),
    showOptionsPanel(el) {
      EventBus.$emit("showOptions", el);
    },
    getscrollLine() {
      this.scrollLine = document.getElementById("bookmarks").offsetWidth - 30;
    },
    clearSearch() {
      this.debounceSearch(null);
    },
    clearLocalStorage() {
      this.search = "";
      this.currentPage = 1;
      this.scrolled = 1;
      this.inFocus = "topic";
      this.sortType = null;
      this.sortDir = null;
      this.ttcResults(0, this.perPage);
    },
    clearBookmarks() {
      this.bookmarks = [];
    },
    clearSorting() {
      this.inFocus = "topic";
      this.sortType = null;
      this.sortDir = null;
      this.ttcResults(
        this.currentPage < 2 ? 0 : (this.currentPage - 1) * this.perPage,
        this.currentPage * this.perPage
      );
    },
    debounceSearch: _.debounce(function (e) {
      this.search = e ? e.target.value.trim() : null;
      this.ttcResults(0, this.currentPage * this.perPage);
    }, 400),
    jumpToPage(page) {
      this.ttcResults((page - 1) * this.perPage, page * this.perPage);
      this.currentPage = page;
    },
    sortTtc(sort) {
      this.sortType = sort;
      this.sortDir && this.sortDir === "asc"
        ? (this.sortDir = "desc")
        : (this.sortDir = "asc");
      this.ttcResults(0, this.perPage);
    },
    ttcForFirstPage() {
      let end = this.currentPage * this.perPage;
      this.ttcResults(
        this.currentPage < 3 ? 0 : (this.currentPage - 2) * this.perPage,
        end
      );
      if (this.currentPage > 2) {
        let scrollObj = document.getElementsByClassName("table-ttc");
        scrollObj[0].scrollTop = 400;
      }
    },
    scroll() {
      let scrollObj = document.getElementsByClassName("table-ttc");
      let scrollObjInner = document.getElementById("scrollerDivTable");
      scrollObj[0].onscroll = () => {
        let bottomOfWindow = scrollObj[0].scrollTop;
        let innerWindow = scrollObjInner.offsetHeight;
        let outerWindow = scrollObj[0].offsetHeight;
        if (bottomOfWindow + 20 > innerWindow - outerWindow) {
          if (this.currentPage < this.totalPages) {
            this.currentPage += 1;
            this.scrolled =
              this.currentPage < this.scrolled
                ? this.scrolled
                : this.currentPage;
            this.ttcResults(
              this.currentPage < 3 ? 0 : (this.currentPage - 2) * this.perPage,
              this.currentPage * this.perPage
            );
            scrollObj[0].scrollTop = scrollObjInner.offsetHeight / 2;
          }
        }
        if (this.currentPage > 1 && bottomOfWindow < 20) {
          this.currentPage -= 1;
          this.ttcResults(
            this.currentPage < 3 ? 0 : (this.currentPage - 2) * this.perPage,
            this.currentPage * this.perPage
          );
          scrollObj[0].scrollTop = 400;
        }
      };
    },
    ttcResults(start, end) {
      console.log("Loading results");
      this.dataItems = _.slice(this.ttcFiltered, start, end);
      if (this.search) {
        this.markSearchedThemes();
      }
      if (this.filterFocused) {
        this.markFilteredThemes();
      }
    },
    markSearchedThemes() {
      this.searchedThemes = [];
      _.each(this.dataItems, (topic) => {
        _.each(topic.children, (theme) => {
          let found = false;
          _.each(theme.children, (concept) => {
            found = concept.name
              .toLowerCase()
              .includes(this.search.toLowerCase());
            if (found) {
              return false;
            }
          });
          if (found) {
            this.searchedThemes.push(theme.id);
          }
        });
      });
    },
    markFilteredThemes() {
      this.filteredThemes = [];
      _.each(this.dataItems, (topic) => {
        _.each(topic.children, (theme) => {
          let found = _.filter(theme.children, (t) => t.filterSize > 0);
          if (found.length > 0) {
            this.filteredThemes.push(theme.id);
          }
        });
      });
    },
    changeInFocus(el) {
      if (el === "topic") {
        this.inFocus = "topic";
        if (this.currentPage > this.totalRows / this.perPage) {
          this.currentPage = Math.round(this.totalRows / this.perPage / 2);
        }
      } else {
        this.inFocus = "theme";
      }
      this.ttcForFirstPage();
    },
    addBM(topic) {
      this.currBm = topic;
      this.$bvModal.show("modal-add-bookmark");
    },
    removeBM(topic) {
      this.bookmarks = _.remove(this.bookmarks, function (n) {
        return n.topic !== topic;
      });
    },
    addBookmarkSubmit(bm) {
      this.bookmarks.push({
        topic: this.currBm,
        bookmark: bm,
      });
      this.currBm = null;
    },
    isBookmark(topic) {
      let bm = this.bookmarks.find((b) => b.topic === topic);
      if (bm) {
        return true;
      }
    },
    goToBookmark(topic) {
      let currPage =
        Math.round(this.getBmPos(topic) / this.perPage) === 0
          ? 1
          : Math.round(this.getBmPos(topic) / this.perPage);
      this.ttcResults(
        currPage < 3 ? 0 : (currPage - 1) * this.perPage,
        currPage * this.perPage
      );
      this.currentPage = currPage;
    },
    getBmPos(topic) {
      return (
        _.findIndex(this.ttcFiltered, function (o) {
          return o.id === topic;
        }) + 1
      );
    },
    getLeftMargin(topic) {
      let pos = this.getBmPos(topic);
      let defMargin = 15;
      return Math.round(
        (pos / this.perPage) *
          (this.scrollLine / (this.totalRows / this.perPage)) +
          defMargin
      );
    },
    async invokeStoredValues() {
      "currentPage" in this.savedMemory
        ? (this.currentPage = this.savedMemory.currentPage)
        : 1;
      "scrolled" in this.savedMemory
        ? (this.scrolled = this.savedMemory.scrolled)
        : 1;
      "search" in this.savedMemory
        ? (this.search = this.savedMemory.search)
        : "";
      "inFocus" in this.savedMemory
        ? (this.inFocus = this.savedMemory.inFocus)
        : "topic";
      "bookmarks" in this.savedMemory
        ? (this.bookmarks = this.savedMemory.bookmarks)
        : [];
      "sortType" in this.savedMemory
        ? (this.sortType = this.savedMemory.sortType)
        : null;
      "sortDir" in this.savedMemory
        ? (this.sortDir = this.savedMemory.sortDir)
        : null;  
      this.ttcForFirstPage();
    },
    getAssociatedFilters(el) {
      if(this.showFilterbadge){
        return this.filterIndex.includes(el);
      }
      else{
        return false;
      }
    },
    toggleFilterbadges(){
      this.showFilterbadge = !this.showFilterbadge;
    }
  },
};
</script>

<style lang="scss" scoped>
.page {
  background: cadetblue;
  width: (100% - 2);
  height: 8px;
  cursor: pointer;
  &:hover {
    background: darkslategray;
  }
}
.flex-right-align {
  margin-left: auto;
  margin-right: 10px;
}
i {
  &.bookmark {
    color: #fcd12a;
  }
}
.bookmarks {
  display: flex;
  position: relative;
  height: 30px;
  .bookmark {
    position: absolute;
    cursor: pointer;
    width: 1px;
    height: 10px;
    background: #000;
    &:hover {
      background: #fcd12a;
    }
  }
}
</style>
